import { useParams } from 'react-router';

import { isReferenceViewID } from '../../modules/referenceView/referenceViewID/isReferenceViewID.ts';
import { selectReferenceBarUI } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';

export const useActiveReferenceBarID = () => {
  const { activeID: routerID } = useParams();
  const { __doNotUseDirectly__ActiveID: stateID } = useAppSelector(selectReferenceBarUI);

  return isReferenceViewID(routerID) ? routerID : stateID;
};
